import { Routes } from '@angular/router';

import { MessageService } from 'primeng/api';

import { AppShellComponent } from 'src/app/core/page/app-shell/app-shell.component';
import { menuResolver } from '@core/resolver/menu.resolver';
import { authGuard } from 'zenith/auth';
import { RootFallbackComponent } from '@shared/component/fallback/root-fallback/root-fallback.component';
import { rootRoleGuard } from '@core/guard/root-role.guard';
import { loginRedirectGuard } from '@core/guard/login-redirect.guard';
import { mainShellDeactivateGuard } from '@core/guard/main-shell-deactivate.guard';
import { MainShellComponent } from './core/page/main-shell/main-shell.component';

export const routes: Routes = [
  {
    path: '',
    component: MainShellComponent,
    title: 'Convivia - La Comunidad en Orden',
    canDeactivate: [mainShellDeactivateGuard],
    children: [
      {
        path: '',
        loadComponent: () =>
          import('src/app/feature/landing/page/index/landing.component').then(m => m.LandingComponent),
      },
      {
        path: 'legal',
        loadChildren: () => import('@feature/legal/legal.module').then(m => m.LegalModule),
      },
    ],
  },
  {
    path: 'login',
    canActivate: [loginRedirectGuard],
    children: [],
  },
  {
    path: 'app',
    component: AppShellComponent,
    providers: [MessageService],
    canActivate: [authGuard, rootRoleGuard],
    loadChildren: () => import('@feature/feature.module').then(m => m.FeatureModule),
    resolve: {
      menu: menuResolver,
    },
  },
  {
    path: 'unauthorized',
    component: RootFallbackComponent,
    title: 'No autorizado',
  },
  {
    path: '**',
    redirectTo: 'app',
  },
];
